module.exports = __webpack_public_path__ + "assets/icons/ic_group_24px.svg";